import AutoCheckbox from '@liveauctioneers/caterwaul-components/lib/Checkbox/AutoCheckbox';
import { BodySecondary, Caption } from '@liveauctioneers/hammer-ui-core/text';
import React from 'react';
import styled from 'styled-components';

import { FacetOption as FacetOptionType } from '@/types/FacetOption';

type Props = {
    onChange: (event: React.MouseEvent<HTMLInputElement>) => void;
    option: FacetOptionType;
};

const CheckboxFacet = (props: Props) => {
    const { onChange, option } = props;

    return (
        <StyledToggleOption suppressHydrationWarning>
            <StyledAutoCheckboxToggler
                disabled={option.count === 0}
                key={`${option.selected}`}
                label={option.name}
                labelDisplay={
                    <>
                        <BodySecondary className="transform-none">{option.name}&nbsp;</BodySecondary>
                        {!isNaN(option.count) && (
                            <Caption color="secondary">
                                <span>({Number(option.count).toLocaleString()})</span>
                            </Caption>
                        )}
                    </>
                }
                name={option.id}
                onChange={onChange}
                startChecked={option.selected}
            />
        </StyledToggleOption>
    );
};

export default React.memo<Props>(CheckboxFacet);

const StyledToggleOption = styled.div`
    padding: 5px 5px 5px 0;
`;

const StyledAutoCheckboxToggler = styled(AutoCheckbox)`
    margin-top: 0;

    input[type='checkbox'] {
        display: none;
    }
`;
